import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    agente_id: { required },
  },
}

export const validateComputed = {
  agenteIdErrors() {
    const errors = []
    if (!this.$v.form.agente_id.$dirty) return errors
    !this.$v.form.agente_id.required && errors.push('Agente é obrigatório.')
    return errors
  },
}
